import apiClient from './apiClient';

export interface QueryParams {
  J301_01: string;      // product code part 1 (6 chars)
  J301_02: string;      // product code part 2 (6 chars)
  J301_17?: string;     // processing instruction code
  J301_11?: string;     // product description
  J301_14?: number;     // width min
  J301_15?: number;     // width max (inch)
  J301_16?: number;     // GSM/SQM
  J301_18?: string;     // processing instruction description
  skipCount?: number;   // blank label slots to skip
  printCopies?: number; // number of copies
  labelFormat?: number; // 1 or 2
}

export interface ProductInfo {
  J301_01: string;
  J301_02: string;
  J301_11: string;
  J301_14: number;
  J301_15: number;
  J301_16: number;
  found: boolean;
}

export interface ProcessInfo {
  code: string;
  desc: string;
  found: boolean;
}

export interface PrintRecord {
  J301_01: string;
  J301_02: string;
  J301_11: string;
  isBlank: boolean;
}

export interface PrintPreviewResult {
  records: PrintRecord[];
  totalCount: number;
  skipCount: number;
  printCopies: number;
  labelFormat: number;
  message?: string;
}

export const pwj30aApi = {
  async lookupProduct(code1: string, code2: string): Promise<{ found: boolean; data?: ProductInfo; message?: string }> {
    const res = await apiClient.get(`/api/pwj30a/product/${encodeURIComponent(code1)}/${encodeURIComponent(code2)}`);
    return res.data;
  },
  async lookupProcess(code: string): Promise<{ found: boolean; data?: ProcessInfo; message?: string }> {
    if (!code?.trim()) return { found: false };
    const res = await apiClient.get(`/api/pwj30a/process/${encodeURIComponent(code.trim())}`);
    return res.data;
  },
  async buildPrint(params: QueryParams): Promise<PrintPreviewResult> {
    const res = await apiClient.post('/api/pwj30a/print', params);
    return res.data;
  },
};
